export type FinancialFieldComponent =
    | 'input'
    | 'dropdown'
    | 'yes_no'
    | 'document_upload'
    | 'tnc_checkbox';

export type FinancialSection =
    | 'identity'
    | 'gst'
    | 'pan'
    | 'bank'
    | 'footer'
    | string;

export interface IFinancialDropdownOption {
    value: string;
    display_value?: string;
    displayValue?: string;
}

export interface IFinancialFieldProps {
    key_name: string;
    section?: FinancialSection;
    editable?: boolean;
    default?: boolean | string;
    submit?: boolean;
    options?: IFinancialDropdownOption[];
    visible_when?: Record<string, boolean | string>;
    transform?: 'uppercase' | string;
    validators?: string[];
    document_type?: string;
    maxLength?: number;
    value_source?: string;
    sync_group?: string;
}

export interface IFinancialFieldConfig {
    id: string;
    type: string;
    component: FinancialFieldComponent;
    label: string;
    title?: string;
    required?: boolean;
    props: IFinancialFieldProps;
}

export interface IDocumentUploadState {
    name: string;
    uploadStatus: string;
    url: string;
}

export type FinancialFormValues = Record<string, any>;

export const SECTION_TITLES: Record<string, string> = {
    identity: '',
    gst: '',
    pan: '',
    bank: 'Bank details',
    footer: '',
};

export const LOCAL_STORAGE_KEY_PREFIX = '_legal_document_object_';

/** Legacy unscoped key — cleared on migrate to avoid cross-group leakage. */
export const LEGACY_LOCAL_STORAGE_KEY = '_legal_document_object_';

export function getLegalDocumentStorageKey(
    partnerId: string,
    groupName: string
): string {
    return `${LOCAL_STORAGE_KEY_PREFIX}${partnerId}_${groupName}`;
}
